if (!customElements.get('swiper-image-text-item')) {
    customElements.define(
        'swiper-image-text-item',
        class SwiperImageTextItem extends HTMLElement {
            constructor() {
                super();
                this.swiperInstance = null;
                this.swiperEl = this.querySelector('.swiper');
            }

            connectedCallback() {
                this.swiperInstance = new Swiper(this.swiperEl, {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 30,
                    breakpoints: {
                        320: {
                            slidesPerView: 1.1,
                            slidesPerGroup: 1,
                            spaceBetween: 15,
                        },
                        750: {
                            slidesPerView: 1.5,
                            slidesPerGroup: 1,
                            spaceBetween: 20,
                        },
                        1001: {
                            slidesPerView: 3,
                            slidesPerGroup: 3,
                            spaceBetween: 30,
                        },
                    }
                })
            }

            disconnectedCallback() {
            }
        }
    );
}
